import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { NetworkHelper } from '../helpers';
import { SHARED_ENV } from '../tokens';

/**
 * Decimals an instrument quantity (holding / order) may be entered with, keyed by the
 * `${tickerId}~${sourceId}` balance symbol. The backend only lists fractional instruments;
 * anything missing trades in whole units.
 */
@Injectable({
  providedIn: 'root',
})
export class InstrumentPrecisionService {
  private readonly networkHelper = inject(NetworkHelper);
  private readonly env = inject(SHARED_ENV);

  private static precisions: Record<string, number> = {};

  static get(symbol: string | null | undefined): number {
    return (symbol && InstrumentPrecisionService.precisions[symbol]) || 0;
  }

  /** Smallest quantity step, e.g. 0.001 for 3 decimals, 1 for whole units. */
  static step(symbol: string | null | undefined): number {
    return Number(Math.pow(10, -InstrumentPrecisionService.get(symbol)).toFixed(8));
  }

  loadPrecisions(): Promise<void> {
    return firstValueFrom(
      this.networkHelper.get<Record<string, number>>(
        `${this.env.host}/instruments/quantity-precisions`
      )
    )
      .then((result) => {
        if (result && typeof result === 'object') {
          InstrumentPrecisionService.precisions = { ...result };
        }
      })
      .catch(() => {});
  }
}
